import * as React from "react";
import {getProductAPI} from '../apis'
import {Avatar, Horizontal, Image, Text, Vertical} from "../../../components/index";
import {imageCut} from '../../../components/Image'
import wx from "../../../utils/wxUtils";
import {feedShowCreateTime} from '../../../utils/uiUtils'
import {downloadApp} from "../utils";

export default class DetailScreen extends React.Component {
    state = {
        loading: true,
        product: null
    };

    constructor() {
        super(...arguments);

        document.title = '作品详情';
        getProductAPI(this.props.match.params._pid).then(res => {
            if (res.isOk) {
                this.setState({product: res.data.data, loading: false})
            }
        })
    }

    render3Images() {
        const {images} = this.state.product;

        const list = [];

        images.map(image => list.push(<img onClick={() => this.onImageClick(image)}
                                           src={imageCut(image, {width: 100, height: 100})} key={image} style={{
                width: '30%',
                height: '30%',
                marginRight: '2%',
                marginTop: '1%'
            }}/>
        ));
        return list
    }


    onImageClick(current) {
        wx.previewImage({
            current, urls: this.state.product.images
        })
    }

    render2Images() {
        const {images} = this.state.product;

        const list = [];

        images.map(image => list.push(<img onClick={() => this.onImageClick(image)}
                                           src={imageCut(image, {width: 180, height: 180})} key={image} style={{
                width: '48%',
                height: '48%',
                marginRight: '2%',
                marginTop: '1%'
            }}/>
        ));
        return list
    }

    render1Images() {
        const {images} = this.state.product;

        return <img src={imageCut(images[0], {width: 300})} onClick={() => this.onImageClick(images[0])}
                    style={{width: '100%'}}/>
    }

    renderImages() {
        const {images} = this.state.product;
        if (images.length === 1) {
            return this.render1Images()
        }
        if (images.length === 2 || images.length === 4 || images.length === 3) {
            return this.render2Images()
        }
        return this.render3Images()
    }

    toHome = () => {
        this.props.history.push('/' + this.state.product.userInfo.userId)
    };

    render() {
        if (this.state.loading)
            return this.renderLoading();

        const {userInfo} = this.state.product
        return <Vertical>
            <Vertical className={'portfolio detail'}>
                <Horizontal onClick={this.toHome}>
                    <Avatar diameter={45} source={{uri: userInfo.avatar}}/>
                    <Vertical style={{flex: 1}}>
                        <Text className={'nickname'}>{userInfo.nickname}</Text>
                        <Text className={'companyName'}>{userInfo.company.name}</Text>
                    </Vertical>

                    <div  onClick={this.toHome} style={{
                        borderColor: '#406599',
                        borderStyle: 'solid',
                        borderWidth: 1,
                        fontSize: 12,
                        width:70,
                        textAlign:'center',
                        borderRadius:28,
                        lineHeight:'28px',
                        height:28,
                        color: '#406599'
                    }}>主页
                    </div>
                </Horizontal>
                {this.state.product.title && <Text className={'title'}>{this.state.product.title}</Text>}
                {this.state.product.description &&
                <Text className={'description'}>{this.state.product.description}</Text>}
                <div className={'imgContainer'}>
                    {this.renderImages()}
                </div>
            </Vertical>
            {this.renderDownload()}
        </Vertical>
    }


    renderDownload() {
        return <div style={{
            textAlign: 'right',
            marginTop: 15,
            color: '#aaa',
            fontSize: 13,
            paddingBottom: 80,
            marginRight: 15
        }}
                    onClick={downloadApp}
        ><span>{feedShowCreateTime(this.state.product.created)}发布于 <span
            style={{color: '#2359a6', textDecoration: 'underline'}}>纹身大咖</span></span>
        </div>
    }

    renderLoading() {
        return <Vertical style={splash.root}>
            <Image source={require('../assets/loading.gif')} style={splash.loading}/>
        </Vertical>
    }
}


const splash = {
    root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff'
    },

    loading: {
        height: 50,
        width: 80
    }
};


// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/DetailScreen.js